export class Payer{
    id:string = '';
    code:string = '';
    name:string = '';
    financialClass:string = 'Unknown';
    portalUrl: string = '';
    phone: string ='';
    ecsPayerId:string = '';
    waystarAuthPayer:string = '';
}